<template>
  <div class="header">
    <div class="title cl">
      <h1 class="fl">
        <a href="https://www.yilieyun.com" title="易猎云招聘管理系统">
        <img
          @click="gotohome"
          class="img100 homelogo"
          src="https://img.yilieyun.com/oss/ylyofficialWebImagse/yly_logo@2x.png"
          alt=""
        />
      </a>
      </h1>
      <ul class="nav fl">
        <router-link
          active-class="active"
          v-for="(item, index) in navData"
          :key="index"
          :to="{ path: item.path, query: routeData }"
          :class="{
            active_s: pathname.includes('/media') && item.name === '关于我们'
            ||pathname.includes('/coverage/1') && item.name === '关于我们'
            ||pathname.includes('/coverage/2') && item.name === '关于我们'
            ||pathname.includes('/coverage/3') && item.name === '关于我们'
            ||pathname.includes('/coverage/4') && item.name === '关于我们'
            ||pathname.includes('/coverage/5') && item.name === '关于我们'
            ||pathname.includes('/coverage/6') && item.name === '关于我们'
            ||pathname.includes('/coverage/7') && item.name === '关于我们'
            ||pathtext=='/'&&item.name === '首页'
            ||pathtext=='/price'&&item.name === '价格'
            ||pathtext=='/product'&&item.name === '产品'
            ||pathtext=='/large'&&item.name === '产品'
            ||pathtext=='/about'&&item.name === '关于我们'
            ||pathtext=='/media'&&item.name === '关于我们'

          }"
          style="position: relative;"
          :style="{width:item.name=='产品'?'80px':''}"
          @click.native="gotochild(item.path)"
          v-show="index<4"
        >
          <span @mouseenter="down_box(item.name)">{{ item.name }} </span>
          <span  @mouseenter="down_box(item.name)" v-show="index==1" style="display:inline-block; width: 40px;height: 70px;position: absolute;left: 60px; ">
            <img v-show="index==1"   class="icon_down" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_down_al.png"/>
          </span>
            <div v-show="index==1&&visible" class="small_lx"></div>
        </router-link>
        <div  v-if="visible" @mouseenter="down_box()"  @mouseleave="down_box_close()" class="poper_box">
          <p @click.stop="todoproduct('1')">RPO招聘管理系统</p>
          <p @click.stop="todoproduct('2')">HR招聘管理系统</p>
        </div>
      </ul>
      <div class="hotline fr cl">
        <img
          src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_telephone@2x.png"
        />
        <span class="tel">400-0588-036</span>
        <span class="ontrial" @click="trial">免费开通</span>
        <span @click="showLoginType()" class="login">登录</span>
      </div>
    </div>
    <!--申请试用组件-->
    <populone :isshow="windowflags" :he="false" @handleChange="changewindows" />
    <login v-if="showLogin"></login>
    <div v-show="visible" @click="()=>visible=false" class="bigbox" ></div>
  </div>
</template>

<script>
import populone from "@/components/views/popul/populone";
import login from "@/components/views/login/index.vue";
import { boo } from "../../../tool/apiboo";

export default {
  data() {
    return {
      visible:false,
      windowflags: false,
      navData: [
        { name: "首页", path: "/" },
        { name: "产品", path: "/product" },
        //{ name: "产品", path: "/large" },
        { name: "价格", path: "/price" },
        { name: "关于我们", path: "/about" },
        { name: "媒体报道", path:"/media"},
        { name: "1",path:"/coverage/1"},
        { name: "2",path:"/coverage/2"},
        { name: "3",path:"/coverage/3"},
        { name: "4",path:"/coverage/4"},
        { name: "5",path:"/coverage/5"},
        { name: "6",path:"/coverage/6"},
        { name: "7",path:"/coverage/7"},
      ],
      pathname: window.location.pathname,
      showLogin: false,
      activePath: "",
      routeData: {},
      pathtext:'/',
      lastout:''
    };
  },
  components: {
    populone,
    login,
  },
  beforeCreate(){
   if(this.$route.query.type==1){
     sessionStorage.setItem('path','/price');
   }
  },
  mounted() {
   let pathstr= sessionStorage.getItem('path');
   this.type= this.$route.params.id;
     console.log(this.type,'路由传过来的值');
   console.log(pathstr,'打印的值');
   if(this.type==2){//平台产品-详情跳转过来
    console.log("zzzzzzzzz");
      this.pathtext='/large'
      this.$router.push({
        path: "/large/2",
      //  query: this.routeData,
      });
   }else if(this.type=='hr'){
    this.pathtext='/product'
      this.$router.push({
        path: "/product/hr",
      //  query: this.routeData,
      });

   }else{
    if(pathstr!=null){
    if(pathstr=='/'){
      this.pathtext='/'
      this.$router.push({
        path: "/",
        query: this.routeData,
      });
    }else if(pathstr=='/product'){
      this.pathtext='/product'
      this.$router.push({
        path: "/product",
        query: this.routeData,
      });
    }else if(pathstr=='/price'){
      this.pathtext='/price'
      this.$router.push({
        path: "/price",
        query: this.routeData,
      });
    }else if(pathstr=='/about'){
       this.pathtext='/about'
      // this.$router.push({
      //   path: "/about",
      //   query: this.routeData,
      // });
    }else if(pathstr=='/media'){
      this.pathtext='/media'
      // this.$router.push({
      //   path: "/media",
      //   query: this.routeData,
      // });
    }
   }
   }

   //console.log(this.pathtext,'###@@@');

    // if(this.type==1){
    //   this.navData.splice(2,1)
    // }else if(this.type==2){
    //   this.navData.splice(1,1)
    // }else{
    //   console.log('没有值的时候');
    //   this.navData.splice(2,1)
    // }

    let utm_source = "";
    let utm_content = "";
    let u = "";
    const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/officialUrlClickNum`;
    let query = this.$route.query;
    if (Object.keys(query).length) {
      utm_source = query.utm_source;
      utm_content = query.utm_content;
      u = query.u;
      let params = new FormData();
      params.append("utm_source", utm_source);
      params.append("utm_content", utm_content);
      params.append("u", u);
      this.$axios({
        url,
        method: "post",
        data: params,
      });
      console.log("sssssssssssssssssss");
    }
    if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    // const { u2 = "" } = this.routeData;
    // if (!u2) {
    //   console.log("WWWW");
    //   zhuge.track("官网加载", {
    //     渠道: "移动",
    //     utm类型: "自然流量",
    //   });
    // } else {
    //   zhuge.track("官网加载", {
    //     渠道: "移动",
    //     utm类型: "驱动流量",
    //   });
    // }
    this.$eventBus.$on("loginModel", (param) => {
      this.showLogin = param;
    });

  },
  watch: {
    immediate:true,
        deep: true,
        $route(to, from){
          localStorage.setItem('supertype','1');
            // console.log('路由变化了')
             console.log('当前页面路由：' + to.path);
             if(to.path=='/'){
              this.pathtext='/'
              sessionStorage.setItem('path','/');
             }else if(to.path=='/price'){
              this.pathtext='/price'
              sessionStorage.setItem('path','/price');
             }else if(to.path=='/product'){
              this.pathtext='/product'
              sessionStorage.setItem('path','/product');
             }else if(to.path=='/about'){
              this.pathtext='/about'
              sessionStorage.setItem('path','/about');
             }else if(to.path=='/large/2'){
              console.log('路由监听',to.path);
              this.pathtext='/large'
              sessionStorage.setItem('path','/large');
             }else if(to.path=='product'){
              this.pathtext='/product'
              sessionStorage.setItem('path','/product');
             }else if(to.path=='/media'){
              this.pathtext='/media'
              sessionStorage.setItem('path','/media');
             }
             console.log(this.pathtext,'看看');
            // console.log('上一个路由：' + from);
            this. navData= [
                { name: "首页", path: "/" },
                { name: "产品", path: "/product" },
                { name: "价格", path: "/price" },
                { name: "关于我们", path: "/about" },
                { name: "媒体报道", path:"/media"},
                { name: "1",path:"/coverage/1"},
                { name: "2",path:"/coverage/2"},
                { name: "3",path:"/coverage/3"},
                { name: "4",path:"/coverage/4"},
                { name: "5",path:"/coverage/5"},
                { name: "6",path:"/coverage/6"},
                { name: "7",path:"/coverage/7"},
              ]
        },

    },
  methods: {
    gotohome() {
      this.$router.push({
        path: "/",
        query: this.routeData,
      });

      if (this.activePath !== "/about") this.pathname = "";
      document.documentElement.scrollTop = 0;
    },
    gotochild(path) {
      this.pathname=window.location.pathname;
      this.activePath = path;
      if (path !== "/about") this.pathname = "";
      document.documentElement.scrollTop = 0;
    },
    trial() {
      this.windowflags = true;
    },
    changewindows(value) {
      this.windowflags = value;
    },
    showLoginType() {
      this.showLogin = true;
    },
    down_box(name){
      if(name=='产品'){
        this.visible=true;
      }
    },
    down_box_close(){
      clearInterval(this.lastout);
      this.lastout= setTimeout(() => {
        this.visible=false;
      }, 800);
    
    },
    todoproduct(val){
      if(val=='1'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          path: "/product",
        });
      }else{
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          path: "/product/hr",
        });
      }

    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
@import "~@/assets/css/style/config.less";

.header {
  width: 100%;
  min-width: 100vw;
  height: 85px;
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  background: #ffffff;
  border-bottom: solid 2px #e4ecff;

  .title {
    padding-top: 14px;
    width: 1490px;
    height: 105px;
    margin: 0 auto;
    font-size: 20px;
    // background:red;
    h1 {
      width: 199px;
      height: 54px;
    }

    .homelogo {
      cursor: pointer;
    }

    .nav {
      position: relative;
      padding-top: 13px;
      width: 770px;
      height: 68px;
      margin-left: 68px;

      a {
        cursor: pointer;
        display: inline-block;
        margin-right: 114px;
        font-size: 24px;
        font-weight: 600;
        color: #405374;
      }

      a:last-child {
        margin-right: 0;
      }
    }

    .hotline {
      position: relative;
      width: 432px;
      height: 81px;
      padding-left: 0;

      img {
        position: absolute;
        display: inline-block;
        width: 27px;
        height: 30px;
        top: 12px;
      }

      .tel {
        display: inline-block;
        height: 30px;
        color: #405374;
        font-size: 22px;
        margin-left: 38px;
        margin-top: 17px;
      }

      .ontrial {
        position: absolute;
        display: inline-block;
        width: 114px;
        height: 50px;
        background: #fb983c;
        border-radius: 7px;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        right: 110px;
      }

      .login {
        float: right;
        cursor: pointer;
        width: 95px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #deefff;
        border-radius: 7px;
        border: 1px solid #0084ff;
        color: #0084ff;
      }
    }
  }
}

.active_s_s {
}

.active {

}

.active_s {
  padding-bottom: 32px;
  border-bottom: solid 4px #0084ff;
  color: #0084ff;
}
.icon_down{
 
}
.poper_box{
  position: absolute;
  min-width: 183px;
  background-color: #ffffff;
  border-radius: 12px;
  top: 60px;
  left: 180px;
  box-shadow: -1px 2px 15px 0px #E2EDFF;
  padding: 20px 0px;
  z-index: 1000;
  p{
    font-size: 16px;
    height: 38px;
    line-height: 38px;
    padding-left: 30px;
    box-sizing: border-box;
    cursor: pointer;
  }
  p:hover{
    color: #0084ff;
    background: #DCEEFF;
  }
}
.small_lx{
  position: absolute;
  width: 0;
  height: 0;
  left: 64px;
  top: 33px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid #ffffff;
 
}
.bigbox{
  position: fixed;
  left: 0;
  top: 50px;
  right: 0;
  bottom: -1000px;
  z-index: 999;
}
</style>





// WEBPACK FOOTER //
// src/components/views/header/index.vue